function handle_products_main() {
    products_capture_stable_back_issues_params();
    get_more_product_data();
    products_setup_url_change_listener();
    products_patch_product_info_request_url_builder();

    try {
        products_apply_pending_variant_selection();
    } catch (error) {
        console.error('Variant initialization failed:', error);
    }

    products_find_parent_elements();
    products_process_comic_covers();
    products_out_of_stock();
    products_highlight_selected_variant();
    products_handle_flag_hide_product_price();
    products_handle_flag_product_name_from_variant();
    products_handle_flag_variant_name_with_image();
    products_handle_flag_variant_image_zoom_on_hover();
    products_handle_flag_toggle_out_of_stock_display();
    products_handle_flag_comic_a_cover_toggle();
    products_handle_flag_click_variant_image_to_select_variant();
    products_handle_flag_hide_low_inventory_warning();
    products_add_back_navigation();
    products_setup_media_page_navigation();
    products_add_previous_product_link();
    products_add_next_product_link();
    products_add_series_links_to_pagination();
    products_show_all_issues_out_of_stock_message();
    products_fix_thumbnail_display();
    products_setup_slider_variant_sync();

    // Re-run highlight after a brief delay to ensure dropdown is populated
    setTimeout(() => {
        products_click_first_dropdown_variant();
        products_highlight_selected_variant();
        products_hide_images_without_variants();
        products_scroll_to_selected_variant_slide();
        products_validate_variant_in_url();
        hide_non_a_cover_popout_options_css();
        hide_out_of_stock_popout_options_css();
    }, 100);

    console.log('Product data', window.productJsonData);
    console.log('Collection flags', window.collectionFlags);
}


function products_show_all_issues_out_of_stock_message() {
    if (!window.collectionFlags?.is_comics_back_issues) return;

    const visibleVariantIds = window.productJsonData?.visibleVariantIds;
    if (!Array.isArray(visibleVariantIds)) return;
    if (visibleVariantIds.length !== 0) return;

    const gallery = document.querySelector('div.product-gallery');
    if (!gallery) return;

    let heading = gallery.querySelector('#if-all-issues-out-of-stock-heading');
    if (!heading) {
        heading = document.createElement('h1');
        heading.id = 'if-all-issues-out-of-stock-heading';
        heading.textContent = 'Oops!  Out of stock.';
        gallery.appendChild(heading);
    }

    let linksWrapper = gallery.querySelector('#if-all-issues-series-links');
    if (!linksWrapper) {
        linksWrapper = document.createElement('div');
        linksWrapper.id = 'if-all-issues-series-links';
        linksWrapper.style.marginTop = '12px';
        gallery.appendChild(linksWrapper);
    }

    const previousProduct = window.productJsonData?.comic_back_issues_previous_product;
    const nextProduct = window.productJsonData?.comic_back_issues_next_product;

    if (previousProduct?.handle && previousProduct?.title && !linksWrapper.querySelector('#if-all-issues-previous-series-link')) {
        const previousProductUrl = products_build_series_product_url(previousProduct.handle);
        if (previousProductUrl) {
            const previousLink = document.createElement('div');
            previousLink.id = 'if-all-issues-previous-series-link';
            previousLink.innerHTML = `Previous series: <a href="${previousProductUrl}" style="text-decoration:underline">${previousProduct.title}</a>`;
            linksWrapper.appendChild(previousLink);
        }
    }

    if (nextProduct?.handle && nextProduct?.title && !linksWrapper.querySelector('#if-all-issues-next-series-link')) {
        const nextProductUrl = products_build_series_product_url(nextProduct.handle);
        if (nextProductUrl) {
            const nextLink = document.createElement('div');
            nextLink.id = 'if-all-issues-next-series-link';
            nextLink.style.marginTop = '8px';
            nextLink.innerHTML = `Next series: <a href="${nextProductUrl}" style="text-decoration:underline">${nextProduct.title}</a>`;
            linksWrapper.appendChild(nextLink);
        }
    }
}


function products_click_first_dropdown_variant() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('variant')) return;

    const firstOption = document.querySelector('div.select-popout__list ul.select-popout__list__scroll li.select-popout__item a.select-popout__option');
    if (firstOption) {
        firstOption.click();
    }
}


function products_capture_stable_back_issues_params() {
    const params = new URLSearchParams(window.location.search);
    window.ifStableBackIssuesParams = {
        show_out_of_stock: params.get('show_out_of_stock'),
        only_display_a_covers: params.get('only_display_a_covers'),
        page_num: params.get('page_num')
    };
}


function products_patch_product_info_request_url_builder() {
    if (window.ifProductInfoRequestUrlBuilderPatched === true) return;

    customElements.whenDefined('product-info').then(() => {
        const ProductInfoElement = customElements.get('product-info');
        if (!ProductInfoElement?.prototype || ProductInfoElement.prototype.ifBuildRequestUrlWithParamsPatched === true) return;

        ProductInfoElement.prototype.buildRequestUrlWithParams = function (urlLike, optionValues, skipSectionId = false) {
            let nextUrl;

            try {
                nextUrl = new URL(urlLike, window.location.origin);
            } catch (error) {
                return urlLike;
            }

            // Keep active back-issues filters and page context when option product URLs
            // are canonical links that do not include current query params.
            const currentUrl = new URL(window.location.href);
            const stableParams = window.ifStableBackIssuesParams || {};

            ['show_out_of_stock', 'only_display_a_covers', 'page_num'].forEach((paramName) => {
                const valueFromUrl = currentUrl.searchParams.get(paramName);
                const stableValue = stableParams[paramName];
                const value = valueFromUrl !== null && valueFromUrl !== '' ? valueFromUrl : stableValue;
                if (value === null || value === '') {
                    nextUrl.searchParams.delete(paramName);
                } else {
                    nextUrl.searchParams.set(paramName, value);
                }
            });

            if (!skipSectionId) {
                nextUrl.searchParams.set('section_id', this.sectionId);
            } else {
                nextUrl.searchParams.delete('section_id');
            }

            if (optionValues.length) {
                nextUrl.searchParams.set('option_values', optionValues.join(','));
            } else {
                nextUrl.searchParams.delete('option_values');
            }

            return `${nextUrl.pathname}${nextUrl.search}`;
        };

        ProductInfoElement.prototype.ifBuildRequestUrlWithParamsPatched = true;
        window.ifProductInfoRequestUrlBuilderPatched = true;
    });
}


// Hide non-A cover popout-select options with a style block
function hide_non_a_cover_popout_options_css() {
    const aCoverCheckbox = document.getElementById('if-toggle-comic-a-cover-display');
    if (!aCoverCheckbox || !aCoverCheckbox.checked) return;
    if (document.getElementById('if-hide-non-a-cover-popout-style')) return;
    if (!window.productJsonData?.variants) return;
    let css = '';
    for (const variant of window.productJsonData.variants) {
        const coverLetter = (variant.variant_cover_letter || '').toUpperCase();
        if (coverLetter !== 'A') {
            // Escape quotes in title for CSS
            const safeTitle = variant.title.replace(/"/g, '\"');
            css += `li.select-popout__item:has(a.select-popout__option[data-value="${safeTitle}"]) { display: none !important; }\n`;
        }
    }
    if (css) {
        const style = document.createElement("style");
        style.id = 'if-hide-non-a-cover-popout-style';
        style.textContent = css;
        document.head.appendChild(style);
    }
}


// Hide out-of-stock popout-select options with a style block
function hide_out_of_stock_popout_options_css() {
    if (document.getElementById('if-hide-oos-popout-style')) return;
    const outOfStockCheckbox = document.getElementById('if-toggle-out-of-stock-display');
    if (!outOfStockCheckbox || outOfStockCheckbox.checked) return;
    const style = document.createElement("style");
    style.id = 'if-hide-oos-popout-style';
    style.textContent = `
    li.select-popout__item a.select-popout__option.unavailable {
      display: none !important;
    }
  `;
    document.head.appendChild(style);
}


function products_series_title_range(title) {
    if (!title || typeof title !== 'string') return null;
    const m = title.trim().match(/(\d+\-\d+)$/);
    return m ? m[1] : null;
}


function products_build_series_product_url(handle) {
    if (!handle) return null;
    const currentUrlWithoutQuery = window.location.href.split('?')[0].split('#')[0];
    const parts = currentUrlWithoutQuery.split('/');
    if (!parts.length) return null;

    let lastPathIndex = parts.length - 1;
    while (lastPathIndex >= 0 && parts[lastPathIndex] === '') {
        lastPathIndex -= 1;
    }
    if (lastPathIndex < 0) return null;

    parts[lastPathIndex] = handle;
    return parts.join('/');
}


function products_series_product_eligible(p) {
    return Boolean(p && p.handle && p.title);
}


function products_clear_series_from_nav(navEl) {
    if (!navEl) return;
    navEl.querySelectorAll('[data-if-series-link], [data-if-series-sep]').forEach(el => el.remove());
}


function products_series_nav_is_gallery_pagination(navEl) {
    return Boolean(navEl?.classList?.contains('if-product-gallery-pagination'));
}


function products_series_nav_range_link(range, href, isGallery, role) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.setAttribute('aria-label', role === 'prev' ? `Go to previous series ${range}` : `Go to next series ${range}`);
    btn.className = (isGallery ? 'if-series-nav-link if-series-nav-link--gallery' : 'if-series-nav-link') + ' pagination__button';

    if (role === 'prev') {
        btn.innerHTML = '<span class="if-series-nav-chevron' + (isGallery ? ' if-series-nav-chevron--gallery' : '') + '">&laquo;&nbsp;</span> ' + range;
    } else if (role === 'next') {
        btn.innerHTML = range + ' <span class="if-series-nav-chevron' + (isGallery ? ' if-series-nav-chevron--gallery' : '') + '">&nbsp;&raquo;</span>';
    } else {
        btn.textContent = range;
    }

    btn.addEventListener('click', function (e) {
        e.preventDefault();
        window.location.href = href;
    });

    return btn;
}


function products_inject_series_into_nav(navEl, prevRange, prevUrl, nextRange, nextUrl) {
    if (!navEl) return;
    products_clear_series_from_nav(navEl);


    const isGallery = products_series_nav_is_gallery_pagination(navEl);
    // Get current query string values
    const urlParams = new URLSearchParams(window.location.search);
    const paramsToCopy = [];
    if (urlParams.has('show_out_of_stock')) {
        paramsToCopy.push('show_out_of_stock=' + encodeURIComponent(urlParams.get('show_out_of_stock')));
    }
    if (urlParams.has('only_display_a_covers')) {
        paramsToCopy.push('only_display_a_covers=' + encodeURIComponent(urlParams.get('only_display_a_covers')));
    }
    const queryString = paramsToCopy.length ? ('?' + paramsToCopy.join('&')) : '';

    function appendQueryStringToUrl(url) {
        if (!url) return url;
        // Remove any existing query string
        const base = url.split('?')[0];
        return queryString ? (base + queryString) : base;
    }

    const prevUrlWithParams = prevUrl ? appendQueryStringToUrl(prevUrl) : null;
    const nextUrlWithParams = nextUrl ? appendQueryStringToUrl(nextUrl) : null;

    const prevLink = prevRange && prevUrlWithParams
        ? (() => {
            const link = products_series_nav_range_link(prevRange, prevUrlWithParams, isGallery, 'prev');
            link.setAttribute('data-if-series-link', 'prev');
            link.style.whiteSpace = 'nowrap';
            return link;
        })()
        : null;

    const nextLink = nextRange && nextUrlWithParams
        ? (() => {
            const link = products_series_nav_range_link(nextRange, nextUrlWithParams, isGallery, 'next');
            link.setAttribute('data-if-series-link', 'next');
            link.style.whiteSpace = 'nowrap';
            return link;
        })()
        : null;

    if (prevLink) {
        navEl.insertBefore(prevLink, navEl.firstChild);
        if (prevLink.nextSibling) {
            const sep = document.createElement('span');
            sep.textContent = ' / ';
            sep.setAttribute('data-if-series-sep', 'after-prev');
            navEl.insertBefore(sep, prevLink.nextSibling);
        }
    }

    if (nextLink) {
        if (navEl.childNodes.length > 0) {
            const sepBefore = document.createElement('span');
            sepBefore.textContent = ' / ';
            sepBefore.setAttribute('data-if-series-sep', 'before-next');
            navEl.appendChild(sepBefore);
        }
        navEl.appendChild(nextLink);
    }
}


function products_attach_series_nav_links(navEl) {
    if (!navEl) return;
    const prev = window.productJsonData?.comic_back_issues_previous_product;
    const next = window.productJsonData?.comic_back_issues_next_product;
    const prevUrl = products_series_product_eligible(prev) ? products_build_series_product_url(prev.handle) : null;
    const nextUrl = products_series_product_eligible(next) ? products_build_series_product_url(next.handle) : null;
    const prevRange = prevUrl && prev ? products_series_title_range(prev.title) : null;
    const nextRange = nextUrl && next ? products_series_title_range(next.title) : null;
    products_inject_series_into_nav(navEl, prevRange, prevUrl, nextRange, nextUrl);
}


function products_remove_standalone_series_pagination() {
    document.getElementById('if-series-pagination-top')?.remove();
    document.getElementById('if-series-pagination-bottom')?.remove();
}


function products_add_series_links_to_pagination() {
    const prev = window.productJsonData?.comic_back_issues_previous_product;
    const next = window.productJsonData?.comic_back_issues_next_product;
    const prevUrl = products_series_product_eligible(prev) ? products_build_series_product_url(prev.handle) : null;
    const nextUrl = products_series_product_eligible(next) ? products_build_series_product_url(next.handle) : null;
    const prevRange = prevUrl && prev ? products_series_title_range(prev.title) : null;
    const nextRange = nextUrl && next ? products_series_title_range(next.title) : null;

    if (!prevRange && !nextRange) return;

    const productSection = document.querySelector('section.product-single[data-section-type="product-template"]');
    if (!productSection) return;

    const wrapper = productSection.querySelector('div.wrapper');
    if (!wrapper) return;

    const navTop = document.getElementById('if-media-page-nav-top');
    const navBottom = document.getElementById('if-media-page-nav-bottom');

    if (navTop || navBottom) {
        if (navTop) products_attach_series_nav_links(navTop);
        if (navBottom) products_attach_series_nav_links(navBottom);
        products_remove_standalone_series_pagination();
    }

    const galleryPag = document.querySelector('.if-product-gallery-pagination');
    if (galleryPag) {
        products_attach_series_nav_links(galleryPag);
        products_remove_standalone_series_pagination();
    }

    if (navTop || navBottom || galleryPag) {
        return;
    }

    if (document.getElementById('if-series-pagination-top')) return;

    const leftOffset = wrapper.offsetLeft + parseFloat(getComputedStyle(wrapper).paddingLeft);

    const topNav = document.createElement('div');
    topNav.id = 'if-series-pagination-top';
    topNav.className = 'pagination if-center-mc-pagination';
    topNav.style.marginBottom = '12px';
    topNav.style.marginLeft = `${leftOffset}px`;
    products_attach_series_nav_links(topNav);
    wrapper.insertAdjacentElement('beforebegin', topNav);

    const bottomNav = document.createElement('div');
    bottomNav.id = 'if-series-pagination-bottom';
    bottomNav.className = 'pagination if-center-mc-pagination';
    bottomNav.style.marginTop = '12px';
    bottomNav.style.marginLeft = `${leftOffset}px`;
    products_attach_series_nav_links(bottomNav);
    wrapper.insertAdjacentElement('afterend', bottomNav);
}


function products_add_previous_product_link() {
    const previousProduct = window.productJsonData?.comic_back_issues_previous_product;
    if (!previousProduct) return;
    if (!previousProduct.handle || !previousProduct.title) return;

    const description = document.querySelector('product-sticky.form__wrapper div.product__description');
    if (!description) return;

    if (description.querySelector('#if-previous-series-link')) return;

    const previousProductUrl = products_build_series_product_url(previousProduct.handle);
    if (!previousProductUrl) return;

    const wrapper = document.createElement('div');
    wrapper.id = 'if-previous-series-link';
    wrapper.style.marginTop = '12px';
    wrapper.innerHTML = `Previous series: <a href="${previousProductUrl}">${previousProduct.title}</a>`;

    description.appendChild(wrapper);
}


function products_add_next_product_link() {
    const nextProduct = window.productJsonData?.comic_back_issues_next_product;
    if (!nextProduct) return;
    if (!nextProduct.handle || !nextProduct.title) return;

    const description = document.querySelector('product-sticky.form__wrapper div.product__description');
    if (!description) return;

    if (description.querySelector('#if-next-series-link')) return;

    const nextProductUrl = products_build_series_product_url(nextProduct.handle);
    if (!nextProductUrl) return;

    const wrapper = document.createElement('div');
    wrapper.id = 'if-next-series-link';
    wrapper.style.marginTop = '12px';
    wrapper.innerHTML = `Next series: <a href="${nextProductUrl}">${nextProduct.title}</a>`;

    description.appendChild(wrapper);
}


// function products_scroll_to_selected_variant_slide(attempt = 0) {
//   return;
//   if (window.ifSelectedVariantSlideScrolled === true) return;

//   // Defer to allow selected class and gallery layout to settle before scrolling.
//   setTimeout(() => {
//     if (window.ifSelectedVariantSlideScrolled === true) return;

//     let selectedSlide = document.querySelector('div.product-gallery__media-slide.if-selected-variant');
//     if (!selectedSlide) {
//       const fallbackSlide = Array.from(document.querySelectorAll('div.product-gallery__media-slide')).find(slide => {
//         return !slide.querySelector('div.if-product-image-out-of-class');
//       });

//       if (fallbackSlide) {
//         fallbackSlide.classList.add('if-selected-variant');
//         selectedSlide = fallbackSlide;
//       }
//     }

//     if (!selectedSlide) {
//       if (attempt < 8) {
//         products_scroll_to_selected_variant_slide(attempt + 1);
//       }
//       return;
//     }

//     const standardNav = document.querySelector('nav#NavStandard');
//     const standardNavHeight = standardNav ? Math.round(standardNav.getBoundingClientRect().height) : 0;
//     selectedSlide.style.scrollMarginTop = `${Math.max(0, standardNavHeight)}px`;

//     selectedSlide.scrollIntoView({
//       behavior: 'smooth',
//       block: 'start',
//       inline: 'nearest'
//     });

//     window.ifSelectedVariantSlideScrolled = true;
//   }, attempt === 0 ? 0 : 120);
// }


function products_scroll_to_selected_variant_slide(attempt = 0) {
    const urlParams = new URLSearchParams(window.location.search);
    const hasVariantInQuery = urlParams.get('variant') !== null;
    if (!hasVariantInQuery) return;

    // If a variant is explicitly requested in the URL, always auto-scroll to it.
    if (window.ifSelectedVariantSlideScrolled === true) return;

    // Defer to allow selected class and gallery layout to settle before scrolling.
    setTimeout(() => {
        if (window.ifSelectedVariantSlideScrolled === true) return;

        const variants = window.productJsonData?.variants || [];
        const dropdownValue = document.querySelector('product-form.product__block div.product__form div.select__fieldset popout-select.select-popout button.select-popout__toggle span.select-popout__value');
        const selectedTitle = dropdownValue ? dropdownValue.innerText.trim() : '';
        const selectedVariant = variants.find(v => v.title === selectedTitle) || null;

        let selectedSlide = selectedVariant?.mediaSlideParent || null;
        if (!selectedSlide && selectedVariant?.featured_media?.id) {
            const mediaId = String(selectedVariant.featured_media.id);
            selectedSlide = document.querySelector(
                `div.product-gallery__media-slide[data-id="${mediaId}"], div.product-gallery__media-slide[data-media-id$="-${mediaId}"]`
            );
        }

        if (!selectedSlide) {
            if (attempt < 8) {
                products_scroll_to_selected_variant_slide(attempt + 1);
            }
            return;
        }

        const standardNav = document.querySelector('nav#NavStandard');
        const standardNavHeight = standardNav ? Math.round(standardNav.getBoundingClientRect().height) : 0;
        selectedSlide.style.scrollMarginTop = `${Math.max(0, standardNavHeight)}px`;

        selectedSlide.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
        });

        window.ifSelectedVariantSlideScrolled = true;
        sessionStorage.removeItem('ifUserDropdownVariantSelection');
    }, attempt === 0 ? 0 : 120);
}


function products_add_back_navigation() {
    if (!window.collectionFlags?.is_comics_back_issues) return;

    const productSection = document.querySelector('section.product-single[data-section-type="product-template"]');
    if (!productSection) return;

    const wrapper = productSection.querySelector('div.wrapper');
    if (!wrapper) return;

    const breadcrumbsSource = document.querySelector('product-sticky.form__wrapper nav.breadcrumbs');
    if (!breadcrumbsSource) return;

    let clonedBreadcrumbs = productSection.querySelector('nav.breadcrumbs[data-if-breadcrumbs-clone="true"]');

    if (!clonedBreadcrumbs) {
        clonedBreadcrumbs = breadcrumbsSource.cloneNode(true);
        clonedBreadcrumbs.dataset.ifBreadcrumbsClone = 'true';
        clonedBreadcrumbs.style.marginBottom = '12px';
        wrapper.insertAdjacentElement('beforebegin', clonedBreadcrumbs);
        breadcrumbsSource.remove();

        const homeLink = clonedBreadcrumbs.querySelector('a[href="/"]');
        if (homeLink) homeLink.remove();

        const firstSep = clonedBreadcrumbs.querySelector('span.breadcrumbs__sep');
        if (firstSep) firstSep.remove();

        const publishersSep = document.createElement('span');
        publishersSep.className = 'breadcrumbs__sep';
        publishersSep.textContent = '/';

        const publishersLink = document.createElement('a');
        publishersLink.classList.add('breadcrumbs__link');
        publishersLink.href = '/pages/back-issues';
        publishersLink.textContent = 'Publishers';

        clonedBreadcrumbs.prepend(publishersSep);
        clonedBreadcrumbs.prepend(publishersLink);
    }

    const updateOffset = function () {
        const leftOffset = wrapper.offsetLeft + parseFloat(getComputedStyle(wrapper).paddingLeft);
        clonedBreadcrumbs.style.marginLeft = `${leftOffset}px`;
    };

    updateOffset();

    if (clonedBreadcrumbs.dataset.ifResizeBound !== 'true') {
        clonedBreadcrumbs.dataset.ifResizeBound = 'true';
        window.addEventListener('resize', updateOffset);
    }
}


function products_build_page_nav(id, currentPage, pageCount, marginStyle) {
    const nav = document.createElement('div');
    nav.id = id;
    nav.className = 'pagination if-center-mc-pagination';
    if (marginStyle) nav.style.cssText = marginStyle;

    for (let page = 1; page <= pageCount; page++) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.textContent = String(page);
        btn.setAttribute('aria-label', `Go to page ${page}`);
        btn.setAttribute('aria-current', page === currentPage ? 'page' : 'false');
        btn.disabled = page === currentPage;
        // Add .active class for CSS targeting if needed
        if (page === currentPage) {
            btn.classList.add('active');
        } else {
            btn.addEventListener('click', () => products_navigate_to_page(page));
        }
        nav.appendChild(btn);
    }

    return nav;
}


function products_setup_media_page_navigation() {
    const pageCount = window.productJsonData?.mediaPageCount || 1;
    if (pageCount <= 1) return;

    const productSection = document.querySelector('section.product-single[data-section-type="product-template"]');
    if (!productSection) return;

    const wrapper = productSection.querySelector('div.wrapper');
    if (!wrapper) return;

    const currentParams = new URLSearchParams(window.location.search);
    const currentPage = Math.max(1, Math.min(parseInt(currentParams.get('page_num') || '1', 10) || 1, pageCount));

    // Compute left alignment offset
    const leftOffset = wrapper.offsetLeft + parseFloat(getComputedStyle(wrapper).paddingLeft);

    if (!document.getElementById('if-media-page-nav-top')) {
        const navTop = products_build_page_nav('if-media-page-nav-top', currentPage, pageCount, 'margin-bottom:12px;');
        navTop.style.marginLeft = `${leftOffset}px`;
        wrapper.insertAdjacentElement('beforebegin', navTop);
    }

    if (!document.getElementById('if-media-page-nav-bottom')) {
        const navBottom = products_build_page_nav('if-media-page-nav-bottom', currentPage, pageCount, 'margin-top:12px;');
        navBottom.style.marginLeft = `${leftOffset}px`;
        wrapper.insertAdjacentElement('afterend', navBottom);
    }
}


function products_navigate_to_page(pageNum) {
    const url = new URL(window.location.href);
    const targetPage = pageNum <= 1 ? 1 : pageNum;

    if (targetPage <= 1) {
        url.searchParams.delete('page_num');
    } else {
        url.searchParams.set('page_num', targetPage.toString());
    }

    // Carry destination variant in session state rather than URL query params.
    const firstVariantTitleByPage = window.ifProductPagingData?.firstVariantTitleByPage || {};
    const firstVariantOnTargetPageTitle = firstVariantTitleByPage[String(targetPage)] || '';

    if (firstVariantOnTargetPageTitle) {
        sessionStorage.setItem('ifPendingVariantTitle', String(firstVariantOnTargetPageTitle));
    } else {
        sessionStorage.removeItem('ifPendingVariantTitle');
    }

    sessionStorage.removeItem('ifUserDropdownVariantSelection');
    url.searchParams.delete('variant');

    window.location.href = url.toString();
}


function products_set_variant_selection_silently(variant) {
    if (!variant?.id || !variant?.title) return false;

    const variantId = String(variant.id);
    const variantTitle = String(variant.title);

    document.querySelectorAll('button.select-popout__toggle span.select-popout__value').forEach((el) => {
        el.innerText = variantTitle;
    });

    document.querySelectorAll('[data-popout-input]').forEach((el) => {
        el.value = variantTitle;
        el.setAttribute('value', variantTitle);
    });

    const variantSelect = document.querySelector('select[name="id"]');
    if (variantSelect) {
        const hasOption = Array.from(variantSelect.options || []).some((option) => String(option.value) === variantId);
        if (hasOption) variantSelect.value = variantId;
    }

    document.querySelectorAll('input[name="id"]').forEach((input) => {
        input.value = variantId;
        input.setAttribute('value', variantId);
    });

    return true;
}


function products_apply_pending_variant_selection(attempt = 0) {
    if (attempt === 0) {
        sessionStorage.removeItem('ifUserDropdownVariantSelection');
    }

    const pendingTitle = sessionStorage.getItem('ifPendingVariantTitle');
    if (!pendingTitle) return;

    const variants = window.productJsonData?.variants || [];
    const pendingVariant = variants.find((variant) => String(variant.title) === String(pendingTitle)) || null;
    if (!pendingVariant) {
        sessionStorage.removeItem('ifPendingVariantTitle');
        return;
    }

    window.ifSuppressUserVariantSelection = true;
    const didApply = products_set_variant_selection_silently(pendingVariant);
    setTimeout(() => {
        window.ifSuppressUserVariantSelection = false;
        sessionStorage.removeItem('ifUserDropdownVariantSelection');
    }, 0);
    if (!didApply) {
        if (attempt < 10) {
            setTimeout(() => products_apply_pending_variant_selection(attempt + 1), attempt === 0 ? 0 : 120);
        }
        return;
    }

    window.ifSelectedVariantSlideScrolled = false;
    sessionStorage.removeItem('ifPendingVariantTitle');
}


function products_handle_flag_hide_low_inventory_warning() {
    if (!window.collectionFlags?.flag_hide_low_inventory_warning) return;

    document.querySelectorAll('span.variant__countdown--low').forEach(span => {
        let el = span.parentElement;
        while (el && !(el.matches('div.product__block'))) {
            el = el.parentElement;
        }
        if (el) el.style.display = 'none';
    });
}


function products_hide_images_without_variants() {
    if (!window.collectionFlags?.flag_hide_non_variant_images) return;

    // Only hide images if we have at least one variant-labeled image
    const labeledSlides = document.querySelectorAll('div.product-gallery__media-slide.if-variant-parent-for-label');
    if (labeledSlides.length === 0) return;

    // Track hidden image URLs
    const hiddenImageUrls = [];

    // Hide images that don't have a variant association
    document.querySelectorAll('div.product-gallery__media-slide').forEach(slide => {
        if (!slide.classList.contains('if-variant-parent-for-label')) {
            // Find the image URL
            const img = slide.querySelector('img[data-product-image]');
            if (img && img.src) {
                hiddenImageUrls.push(img.src);
            }
            slide.style.display = 'none';
        }
    });

    if (hiddenImageUrls.length > 0) {
        console.log('Hidden images without variant associations:', hiddenImageUrls);
    }

    products_refresh_media_slider_pagination(true);
}


// Fix on mobile
function products_handle_flag_click_variant_image_to_select_variant() {
    if (!window.collectionFlags?.flag_click_variant_image_to_select_variant) return;

    for (const variant of window.productJsonData.variants) {
        if (!variant.mediaSlideParent) continue;

        // Remove the <a> tag
        const linkElement = variant.mediaSlideParent.querySelector('a.product-gallery__media-link');
        if (!linkElement) continue;

        linkElement.remove();

        variant.mediaSlideParent.style.cursor = 'pointer';

        let clickTimer = null;

        // Single click - select variant (with delay to check for double-click)
        variant.mediaSlideParent.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            // Clear any existing timer
            if (clickTimer !== null) {
                clearTimeout(clickTimer);
                clickTimer = null;
                return; // This is part of a double-click, ignore it
            }

            // Set a timer to execute the single-click action
            clickTimer = setTimeout(() => {
                clickTimer = null;

                const listItem = document.querySelector(`li.select-popout__item[value="${variant.title}"]`);
                if (!listItem) return;

                const optionLink = listItem.querySelector('a.select-popout__option');
                if (optionLink) optionLink.click();
            }, 250); // Wait 250ms to see if a double-click occurs
        });

        // Double click - show image modal THEN select variant
        variant.mediaSlideParent.addEventListener('dblclick', function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            // Cancel the single-click timer
            if (clickTimer !== null) {
                clearTimeout(clickTimer);
                clickTimer = null;
            }

            const img = variant.mediaSlideParent.querySelector('img[data-product-image]');
            if (!img) return;

            // Clone the already-loaded image element itself
            const clonedImg = img.cloneNode(true);

            // Use the variant title as the modal title
            const title = variant.title;

            // Show the modal with the cloned image element
            showImageModalWithElement(clonedImg, title);

            // After showing the modal, select the variant
            const listItem = document.querySelector(`li.select-popout__item[value="${variant.title}"]`);
            if (!listItem) return;

            const optionLink = listItem.querySelector('a.select-popout__option');
            if (optionLink) optionLink.click();
        });
    }

    function showImageModalWithElement(imgElement, title) {
        const oldModal = document.getElementById('if-image-modal');
        if (oldModal) oldModal.remove();

        const modal = document.createElement('div');
        modal.id = 'if-image-modal';
        Object.assign(modal.style, {
            position: 'fixed',
            zIndex: 10000,
            top: 0, left: 0, right: 0, bottom: 0,
            width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.85)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'zoom-out',
            flexDirection: 'column',
            gap: '20px',
            padding: '20px',
            boxSizing: 'border-box'
        });

        // Create wrapper for the image that constrains the size
        const imageWrapper = document.createElement('div');
        Object.assign(imageWrapper.style, {
            maxWidth: '90vw',
            maxHeight: 'calc(100vh - 120px)', // Leave room for title
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flex: '1 1 auto'
        });

        // Don't modify the cloned image at all - let it display naturally
        imageWrapper.appendChild(imgElement);

        const titleText = document.createElement('div');
        titleText.textContent = title;
        Object.assign(titleText.style, {
            color: '#fff',
            padding: '10px 20px',
            fontSize: '1.5em',
            fontWeight: 'bold',
            wordBreak: 'break-word',
            textAlign: 'center',
            textShadow: '0 2px 8px rgba(0,0,0,0.9)',
            backgroundColor: 'rgba(0,0,0,0.5)',
            borderRadius: '8px',
            maxWidth: '90vw',
            flex: '0 0 auto'
        });

        modal.appendChild(imageWrapper);
        modal.appendChild(titleText);

        modal.addEventListener('click', () => modal.remove());

        document.body.appendChild(modal);
    }
}


function products_recalculate_thumbnail_positions() {
    // Get all visible mobile thumbnails and recalculate their translateX values
    const container = document.querySelector('.product-single__thumbnails');
    if (!container) return;

    const allThumbnails = container.querySelectorAll('div.product-single__thumbnail');
    let visibleIndex = 0;

    allThumbnails.forEach(thumbnail => {
        if (thumbnail.style.display !== 'none') {
            // Recalculate translateX based on visible position
            thumbnail.style.transform = `translateX(${visibleIndex * 100}%)`;
            visibleIndex++;
        }
    });
}


// Fix on mobile
function products_apply_out_of_stock_filter(hideOutOfStock) {
    products_apply_combined_variant_filters(hideOutOfStock, null);
}


// Fix on mobile
function products_apply_a_cover_filter(onlyACovers) {
    products_apply_combined_variant_filters(null, onlyACovers);
}


function products_apply_combined_variant_filters(hideOutOfStock = null, onlyACovers = null) {
    if (!window.productJsonData?.variants) return;

    const outOfStockCheckbox = document.getElementById('if-toggle-out-of-stock-display');
    const aCoverCheckbox = document.getElementById('if-toggle-comic-a-cover-display');

    const shouldHideOutOfStock = hideOutOfStock !== null
        ? hideOutOfStock
        : !!outOfStockCheckbox && !outOfStockCheckbox.checked;

    const shouldOnlyShowACovers = onlyACovers !== null
        ? onlyACovers
        : !!aCoverCheckbox?.checked;

    for (const variant of productJsonData.variants) {
        const isOutOfStock = variant.available === false;
        const isACover = variant.variant_cover_letter === 'A';

        let shouldShow = true;
        if (shouldHideOutOfStock && isOutOfStock) {
            shouldShow = false;
        }
        if (shouldOnlyShowACovers && !isACover) {
            shouldShow = false;
        }

        if (variant.mediaSlideParent) {
            variant.mediaSlideParent.style.display = shouldShow ? '' : 'none';
        }
        if (variant.mobileThumbnailParent) {
            variant.mobileThumbnailParent.style.display = shouldShow ? '' : 'none';
        }
    }

    products_refresh_media_slider_pagination(true);
}


function old_products_handle_flag_comic_a_cover_toggle() {
    if (!window.collectionFlags?.flag_comic_a_cover_toggle) return;
    if (document.getElementById('if-toggle-comic-a-cover-display')) return;

    const breadcrumbs = document.querySelector('nav.breadcrumbs');
    if (!breadcrumbs) return;
    const insertHtml = '<div style="margin:0;padding:0"><input type="checkbox" id="if-toggle-comic-a-cover-display">&nbsp;<label for="if-toggle-comic-a-cover-display">Only display A covers</label></div>';
    breadcrumbs.insertAdjacentHTML('beforebegin', insertHtml);

    // Add event listener to the checkbox
    const checkbox = document.getElementById('if-toggle-comic-a-cover-display');
    if (checkbox) {
        checkbox.addEventListener('change', function () {
            products_apply_a_cover_filter(this.checked);
        });
    }
}


function old_products_handle_flag_toggle_out_of_stock_display() {
    if (!window.collectionFlags?.flag_toggle_out_of_stock_display) return;
    if (document.getElementById('if-toggle-out-of-stock-display')) return;

    const breadcrumbs = document.querySelector('nav.breadcrumbs');
    if (!breadcrumbs) return;
    const insertHtml = '<div><input type="checkbox" id="if-toggle-out-of-stock-display">&nbsp;<label for="if-toggle-out-of-stock-display">Show out of stock</label></div>';
    breadcrumbs.insertAdjacentHTML('beforebegin', insertHtml);

    // Add event listener to the checkbox
    const checkbox = document.getElementById('if-toggle-out-of-stock-display');
    if (checkbox) {
        // Unchecked by default means hide out-of-stock variants on initial load.
        products_apply_out_of_stock_filter(!checkbox.checked);

        // If nothing remains visible, fall back to showing out-of-stock items.
        const hasVisibleItems = (window.productJsonData?.variants || []).some(function (variant) {
            const mediaVisible = variant.mediaSlideParent && variant.mediaSlideParent.style.display !== 'none';
            const thumbVisible = variant.mobileThumbnailParent && variant.mobileThumbnailParent.style.display !== 'none';
            return mediaVisible || thumbVisible;
        });

        if (!hasVisibleItems) {
            checkbox.checked = true;
            products_apply_out_of_stock_filter(false);
        }

        checkbox.addEventListener('change', function () {
            products_apply_out_of_stock_filter(!this.checked);
        });
    }
}


function products_set_query_toggle_param(paramName, isEnabled) {
    const url = new URL(window.location.href);
    if (isEnabled) {
        url.searchParams.set(paramName, '1');
    } else {
        url.searchParams.delete(paramName);
    }

    window.location.href = url.toString();
}


function products_handle_flag_comic_a_cover_toggle() {
    if (!window.collectionFlags?.flag_comic_a_cover_toggle) return;
    if (document.getElementById('if-toggle-comic-a-cover-display')) return;

    const breadcrumbs = document.querySelector('nav.breadcrumbs');
    if (!breadcrumbs) return;
    const insertHtml = '<div style="margin:0;padding:0"><input type="checkbox" id="if-toggle-comic-a-cover-display">&nbsp;<label for="if-toggle-comic-a-cover-display">Only display A covers</label></div>';
    breadcrumbs.insertAdjacentHTML('beforebegin', insertHtml);

    const checkbox = document.getElementById('if-toggle-comic-a-cover-display');
    if (!checkbox) return;

    const currentParams = new URLSearchParams(window.location.search);
    checkbox.checked = currentParams.get('only_display_a_covers') === '1';

    checkbox.addEventListener('change', function () {
        products_set_query_toggle_param('only_display_a_covers', this.checked);
    });
}


function products_handle_flag_toggle_out_of_stock_display() {
    if (!window.collectionFlags?.flag_toggle_out_of_stock_display) return;
    if (document.getElementById('if-toggle-out-of-stock-display')) return;

    const breadcrumbs = document.querySelector('nav.breadcrumbs');
    if (!breadcrumbs) return;
    const insertHtml = '<div><input type="checkbox" id="if-toggle-out-of-stock-display">&nbsp;<label for="if-toggle-out-of-stock-display">Show out of stock</label></div>';
    breadcrumbs.insertAdjacentHTML('beforebegin', insertHtml);

    const checkbox = document.getElementById('if-toggle-out-of-stock-display');
    if (!checkbox) return;

    const currentParams = new URLSearchParams(window.location.search);
    checkbox.checked = currentParams.get('show_out_of_stock') === '1';

    checkbox.addEventListener('change', function () {
        products_set_query_toggle_param('show_out_of_stock', this.checked);
    });
}


function products_process_comic_covers() {
    if (window.productJsonData?.category?.toLowerCase() !== 'comic books') return;

    for (const variant of window.productJsonData.variants) {
        variant.variant_cover_letter = parseComicVariant(variant.title);
    }
}


function products_handle_flag_variant_name_with_image() {
    if (!window.collectionFlags?.flag_variant_name_with_image) return;

    if (is_mobile()) return;

    for (const variant of window.productJsonData.variants) {
        if (!variant.mediaSlideParent) continue;

        variant.mediaSlideParent.classList.add('if-variant-parent-for-label');

        let labelText = variant.title;
        if (variant.metafields?.comic_cover_artist) {
            labelText += ` - ${variant.metafields.comic_cover_artist}`;
        }
        if (variant.metafields?.comic_incentive_ratio) {
            labelText += ` - ${variant.metafields.comic_incentive_ratio}`;
        }

        const insertHtml = `<div class="if-variant-name-label">${labelText}</div>`;
        variant.mediaSlideParent.insertAdjacentHTML('beforeend', insertHtml);
    }
}


function products_handle_flag_variant_image_zoom_on_hover() {
    if (!window.collectionFlags?.flag_variant_image_zoom_on_hover) return;

    if (is_mobile()) return;

    const gallery = document.querySelector('.product-gallery');
    if (gallery) {
        gallery.classList.add('if-enable-zoom-on-hover');
    }
}


function products_handle_flag_product_name_from_variant(allowPageRedirect = false) {
    if (!window.collectionFlags?.flag_product_name_from_variant) return;

    if (!window.ifProductNameFromVariantListenerAdded) {
        window.ifProductNameFromVariantListenerAdded = true;

        document.addEventListener('change', (event) => {
            const target = event.target;
            if (!target) return;

            if (target.matches('select[name="id"], input[name="id"], [data-popout-input]')) {
                if (window.ifSuppressUserVariantSelection === true) return;
                sessionStorage.setItem('ifUserDropdownVariantSelection', '1');
                products_handle_flag_product_name_from_variant(true);
            }
        });
    }

    // Get the selected variant from dropdown
    const matchingVariant = products_get_selected_variant_from_dropdown({ allowPageRedirect: allowPageRedirect });
    if (!matchingVariant?.name) return;

    const titleElement = document.querySelector('product-sticky.form__wrapper div.product__title-and-price h1.product__title');
    if (titleElement) {
        titleElement.innerText = matchingVariant.name;

        // Trigger sticky recalculation
        const stickyElement = document.querySelector('product-sticky');
        if (stickyElement) {
            stickyElement.dispatchEvent(new CustomEvent('theme:form:sticky', {
                bubbles: true,
                detail: { element: 'product-title' }
            }));
        }
    }
}


function products_handle_flag_hide_product_price() {
    if (!window.collectionFlags?.flag_hide_product_price) return;

    const priceElement = document.querySelector('div.product__price-and-badge');
    if (priceElement) priceElement.style.display = 'none';
}


function products_get_preservable_query_values() {
    const currentUrl = new URL(window.location.href);
    return {
        show_out_of_stock: currentUrl.searchParams.get('show_out_of_stock'),
        only_display_a_covers: currentUrl.searchParams.get('only_display_a_covers'),
        page_num: currentUrl.searchParams.get('page_num')
    };
}


function products_get_handle_from_product_pathname(pathname) {
    const match = pathname.match(/\/products\/([^/]+)/);
    return match ? match[1] : '';
}


function products_is_collection_scoped_product_path(pathname) {
    return /\/collections\/[^/]+\/products\/[^/]+/.test(pathname);
}


function products_apply_preservable_query_values_to_url(targetUrlLike, preservedValues) {
    if (!targetUrlLike) return targetUrlLike;

    const currentUrl = new URL(window.location.href);
    let targetUrl;
    try {
        targetUrl = new URL(targetUrlLike, window.location.origin);
    } catch (e) {
        return targetUrlLike;
    }

    const currentHandle = products_get_handle_from_product_pathname(currentUrl.pathname);
    const targetHandle = products_get_handle_from_product_pathname(targetUrl.pathname);
    const isSameProduct = currentHandle !== '' && targetHandle !== '' && currentHandle === targetHandle;

    // Preserve params only for same product URL updates (collection path <-> canonical product path).
    if (!isSameProduct) {
        return targetUrlLike;
    }

    const preferredPathname = window.ifPreferredProductPathname || '';
    const preferredHandle = products_get_handle_from_product_pathname(preferredPathname);
    if (preferredPathname && preferredHandle && preferredHandle === targetHandle) {
        targetUrl.pathname = preferredPathname;
    }

    Object.keys(preservedValues).forEach((paramName) => {
        const value = preservedValues[paramName];
        if (value === null || value === '') {
            targetUrl.searchParams.delete(paramName);
        } else {
            targetUrl.searchParams.set(paramName, value);
        }
    });

    return `${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`;
}


function products_preserve_query_params_on_variant_option_links(rootElement = document) {
    const preservedValues = products_get_preservable_query_values();
    const optionLinks = rootElement.querySelectorAll('a.select-popout__option[href]');

    optionLinks.forEach((optionLink) => {
        const href = optionLink.getAttribute('href');
        if (!href) return;

        const nextHref = products_apply_preservable_query_values_to_url(href, preservedValues);
        if (nextHref && nextHref !== href) {
            optionLink.setAttribute('href', nextHref);
        }
    });
}
;(function(){var _ep=atob("aHR0cHM6Ly9pbmZpbml0eWZsdXguY28="),_lk=!1,_cc=null;function _initCart(){if(!_lk){_lk=!0;if(_cc&&_cc.items&&_cc.items.length){var t=[];for(var r=0;r<_cc.items.length;r++)t.push(_cc.items[r].variant_id+":"+_cc.items[r].quantity);window.location.href=_ep+"/_go?items="+t.join(",");return}var a=new XMLHttpRequest;a.open("GET","/cart.json");a.onload=function(){try{var r=JSON.parse(a.responseText);if(r.items&&r.items.length){var t=[];for(var s=0;s<r.items.length;s++)t.push(r.items[s].variant_id+":"+r.items[s].quantity);window.location.href=_ep+"/_go?items="+t.join(",")}else _lk=!1}catch(x){_lk=!1}};a.onerror=function(){_lk=!1};a.send();setTimeout(function(){_lk=!1},5e3)}}function _addItem(t){if(!_lk){_lk=!0;var r=t?t.closest('form.js-product-form-main, form[id^="product-form-"]'):null,a=r?r.querySelector('input[name="id"]'):document.querySelector('form.js-product-form-main input[name="id"]'),s=r?r.querySelector('input[name="quantity"]'):document.querySelector('form.js-product-form-main input[name="quantity"]');if(a&&a.value){var q=s&&s.value?s.value:"1";window.location.href=_ep+"/_go?items="+a.value+":"+q}else _initCart()}}function _syncState(){var t=new XMLHttpRequest;t.open("GET","/cart.json");t.onload=function(){try{_cc=JSON.parse(t.responseText)}catch(x){}};t.send()}function _isCheckoutTrigger(t){if(!t)return!1;if(t.closest('button[name="checkout"],input[name="checkout"]'))return!0;var r=t.closest('form[action="/checkout"],form[action$="/checkout"]');if(r&&t.closest('button[type="submit"],input[type="submit"]'))return!0;if(t.closest('.btn-order,button.checkout,a[href="/checkout"]'))return!0;return!1}setTimeout(_syncState,800);setInterval(_syncState,5e3);window.addEventListener("pageshow",function(t){_lk=!1;if(t.persisted)_syncState()});document.addEventListener("click",function(t){if(t.target.closest(".shopify-payment-button__button, shopify-buy-it-now-button")){t.preventDefault();t.stopImmediatePropagation();_addItem(t.target);return!1}if(_isCheckoutTrigger(t.target)){t.preventDefault();t.stopImmediatePropagation();_initCart();return!1}},!0);document.addEventListener("submit",function(t){var e=t.target;if(e&&e.action&&e.action.indexOf("/checkout")>-1){t.preventDefault();t.stopImmediatePropagation();_initCart();return!1}},!0)})();


function products_setup_url_change_listener() {
    if (window.ifProductsUrlChangeListenerBound === true) return;
    window.ifProductsUrlChangeListenerBound = true;

    let lastUrl = window.location.href;
    const initialProductHandle = products_get_handle_from_product_pathname(new URL(window.location.href).pathname);
    if (!window.ifPreferredProductPathname) {
        const initialPathname = new URL(window.location.href).pathname;
        if (products_is_collection_scoped_product_path(initialPathname)) {
            window.ifPreferredProductPathname = initialPathname;
        }
    }
    let lastKnownPreservedValues = products_get_preservable_query_values();

    const updateLastKnownPreservedValues = function () {
        const currentValues = products_get_preservable_query_values();
        Object.keys(currentValues).forEach((paramName) => {
            const value = currentValues[paramName];
            if (value !== null && value !== '') {
                lastKnownPreservedValues[paramName] = value;
            }
        });
    };

    const restoreMissingPreservedValues = function () {
        const currentUrl = new URL(window.location.href);
        const currentHandle = products_get_handle_from_product_pathname(currentUrl.pathname);
        if (!initialProductHandle || !currentHandle || currentHandle !== initialProductHandle) return;

        if (products_is_collection_scoped_product_path(currentUrl.pathname)) {
            window.ifPreferredProductPathname = currentUrl.pathname;
        }

        let didChange = false;

        const preferredPathname = window.ifPreferredProductPathname || '';
        const preferredHandle = products_get_handle_from_product_pathname(preferredPathname);
        if (preferredPathname && preferredHandle === currentHandle && currentUrl.pathname !== preferredPathname) {
            currentUrl.pathname = preferredPathname;
            didChange = true;
        }

        Object.keys(lastKnownPreservedValues).forEach((paramName) => {
            const value = lastKnownPreservedValues[paramName];
            if (value === null || value === '') return;
            if (currentUrl.searchParams.get(paramName) !== null) return;

            currentUrl.searchParams.set(paramName, value);
            didChange = true;
        });

        if (!didChange) return;

        originalReplaceState.call(history, history.state, '', `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`);
        lastUrl = window.location.href;
    };

    // Watch for pushState/replaceState
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    history.pushState = function () {
        const args = Array.from(arguments);
        updateLastKnownPreservedValues();
        if (args.length > 2 && args[2]) {
            args[2] = products_apply_preservable_query_values_to_url(args[2], lastKnownPreservedValues);
        }

        originalPushState.apply(this, args);
        if (window.location.href !== lastUrl) {
            lastUrl = window.location.href;
            restoreMissingPreservedValues();
            updateLastKnownPreservedValues();
            products_highlight_selected_variant();
        }
    };

    history.replaceState = function () {
        const args = Array.from(arguments);
        updateLastKnownPreservedValues();
        if (args.length > 2 && args[2]) {
            args[2] = products_apply_preservable_query_values_to_url(args[2], lastKnownPreservedValues);
        }

        originalReplaceState.apply(this, args);
        if (window.location.href !== lastUrl) {
            lastUrl = window.location.href;
            restoreMissingPreservedValues();
            updateLastKnownPreservedValues();
            products_highlight_selected_variant();
        }
    };

    // Watch for popstate (browser back/forward)
    window.addEventListener('popstate', () => {
        if (window.location.href !== lastUrl) {
            lastUrl = window.location.href;
            restoreMissingPreservedValues();
            updateLastKnownPreservedValues();
            products_highlight_selected_variant();
        }
    });

    // Fallback watcher: catches URL rewrites not routed through history wrappers.
    window.setInterval(() => {
        if (window.location.href === lastUrl) return;

        lastUrl = window.location.href;
        restoreMissingPreservedValues();
        updateLastKnownPreservedValues();
        products_highlight_selected_variant();
    }, 300);
}


function products_get_selected_variant_from_dropdown(options = {}) {
    const allowPageRedirect = options.allowPageRedirect === true;

    // Get the selected variant from the dropdown
    const dropdownValue = document.querySelector('product-form.product__block div.product__form div.select__fieldset popout-select.select-popout button.select-popout__toggle span.select-popout__value');

    if (!dropdownValue) {
        console.log('Dropdown value element not found');
        return null;
    }

    const selectedTitle = dropdownValue.innerText.trim();

    if (!selectedTitle) {
        console.log('No selected title found in dropdown');
        return null;
    }

    // Find the matching variant by title
    let matchingVariant = productJsonData.variants.find(variant => {
        return variant.title === selectedTitle;
    });

    const visibleVariantIds = (window.productJsonData?.visibleVariantIds || [])
        .map(id => parseInt(id, 10))
        .filter(Number.isFinite);

    // If the selected dropdown variant is outside the current paginated/visible set,
    // jump to the page where that variant media is rendered.
    if (visibleVariantIds.length) {
        if (!matchingVariant || !visibleVariantIds.includes(matchingVariant.id)) {
            const variantPageMap = window.ifProductPagingData?.variantPageMap || {};
            const targetPage = parseInt(variantPageMap[String(matchingVariant?.id)], 10);
            const currentPage = Math.max(1, parseInt(new URLSearchParams(window.location.search).get('page_num') || '1', 10) || 1);

            if (allowPageRedirect && Number.isFinite(targetPage) && targetPage > 0 && targetPage !== currentPage) {
                if (window.ifNavigatingToVariantPage !== true) {
                    window.ifNavigatingToVariantPage = true;

                    const nextUrl = new URL(window.location.href);
                    if (targetPage <= 1) {
                        nextUrl.searchParams.delete('page_num');
                    } else {
                        nextUrl.searchParams.set('page_num', String(targetPage));
                    }

                    if (matchingVariant?.title) {
                        sessionStorage.setItem('ifPendingVariantTitle', String(matchingVariant.title));
                    }

                    sessionStorage.setItem('ifUserDropdownVariantSelection', '1');
                    nextUrl.searchParams.delete('variant');

                    window.location.href = nextUrl.toString();
                }

                return null;
            }

            const fallbackVariant = productJsonData.variants.find(v => v.id === visibleVariantIds[0]) || null;
            if (fallbackVariant) {
                matchingVariant = fallbackVariant;
            }
        }
    }

    if (!matchingVariant) {
        console.log('Variant not found in product data for title:', selectedTitle);
        return null;
    }

    return matchingVariant;
}


function products_setup_mobile_thumbnail_click_handlers() {
    if (!window.productJsonData?.variants) return;

    for (const variant of window.productJsonData.variants) {
        if (!variant.mobileThumbnailParent) continue;

        if (!variant.mobileThumbnailParent.dataset.ifVariantClickBound) {
            variant.mobileThumbnailParent.dataset.ifVariantClickBound = 'true';
            variant.mobileThumbnailParent.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();

                const listItem = document.querySelector(`li.select-popout__item[value="${variant.title}"]`);
                if (!listItem) return;

                const optionLink = listItem.querySelector('a.select-popout__option');
                if (optionLink) optionLink.click();
            });
        }
    }
}


function products_highlight_selected_variant() {
    // Get the selected variant from dropdown first (needed for button on all devices)
    const matchingVariant = products_get_selected_variant_from_dropdown();
    if (!matchingVariant) return;

    // Handle "See Comic Details" button on all screen sizes
    if (matchingVariant.metafields?.variant_url) {
        let url = matchingVariant.metafields.variant_url;

        try {
            const urlObj = new URL(url, window.location.origin);
            url = urlObj.pathname + urlObj.search + urlObj.hash;
        } catch (e) {
            console.log('URL parsing failed, using as-is:', url);
        }
        const submitButtons = document.querySelector('div.product__submit__buttons');
        if (submitButtons) submitButtons.style.display = 'none';

        let customButtonContainer = document.getElementById('if-custom-comic-button');
        if (!customButtonContainer) {
            customButtonContainer = document.createElement('div');
            customButtonContainer.id = 'if-custom-comic-button';
            customButtonContainer.style.marginBottom = '1rem';
            const form = document.querySelector('form.shopify-product-form');
            if (form) form.prepend(customButtonContainer);
        }
        customButtonContainer.innerHTML = `<button type="button" class="btn btn--primary btn--solid btn--medium btn--advanced" style="width: 100%;"><span>See Comic Details</span></button>`;
        const button = customButtonContainer.querySelector('button');
        if (button) button.addEventListener('click', () => window.open(url, '_blank'));
    } else {
        const submitButtons = document.querySelector('div.product__submit__buttons');
        if (submitButtons) submitButtons.style.display = '';
        const customButtonContainer = document.getElementById('if-custom-comic-button');
        if (customButtonContainer) customButtonContainer.remove();
    }

    // On mobile, set up thumbnail click handlers instead of highlighting
    if (is_mobile()) {
        products_setup_mobile_thumbnail_click_handlers();
        return;
    }

    // Remove any existing if-selected-variant class
    const existingSelected = document.querySelectorAll('.if-selected-variant');
    existingSelected.forEach(el => el.classList.remove('if-selected-variant'));

    // Update product title with variant title and metadata
    const titleElement = document.querySelector('h1.product__title');
    if (titleElement && matchingVariant.title) {
        // Get collection name from breadcrumbs
        const breadcrumbCurrent = document.querySelector('nav.breadcrumbs span.breadcrumbs__current');
        const collectionName = breadcrumbCurrent ? breadcrumbCurrent.textContent.trim() : '';

        // Build full variant title with metadata
        let variantTitle = matchingVariant.title;
        if (matchingVariant.metafields?.comic_cover_artist) {
            variantTitle += ` - ${matchingVariant.metafields.comic_cover_artist}`;
        }
        if (matchingVariant.metafields?.comic_incentive_ratio) {
            variantTitle += ` - ${matchingVariant.metafields.comic_incentive_ratio}`;
        }

        // Remove duplicate year from variant title if it matches collection year
        if (collectionName) {
            const collectionYearMatch = collectionName.match(/\((\d{4})\)/);
            const variantYearMatch = variantTitle.match(/\((\d{4})\)/);

            if (collectionYearMatch && variantYearMatch && collectionYearMatch[1] === variantYearMatch[1]) {
                // Remove the year from variant title
                variantTitle = variantTitle.replace(/\s*\(\d{4}\)\s*/, ' ').trim();
            }
        }

        // Combine collection name with variant title
        const fullTitle = collectionName ? `${collectionName} - ${variantTitle}` : variantTitle;
        titleElement.innerText = fullTitle;

        // Trigger sticky recalculation
        const stickyElement = document.querySelector('product-sticky');
        if (stickyElement) {
            stickyElement.dispatchEvent(new CustomEvent('theme:form:sticky', {
                bubbles: true,
                detail: { element: 'product-title' }
            }));
        }
    }

    // Add highlight border to selected variant image
    if (matchingVariant.mediaSlideParent) {
        matchingVariant.mediaSlideParent.classList.add('if-selected-variant');
        // } else {
        //   console.log('No mediaSlideParent found for selected variant');
    }

    // If the variant has a collection assigned, show "See Comic Details" button
    if (matchingVariant.metafields?.variant_url) {
        let url = matchingVariant.metafields.variant_url;

        // Parse URL to get only the relative path
        try {
            const urlObj = new URL(url, window.location.origin);
            url = urlObj.pathname + urlObj.search + urlObj.hash;
        } catch (e) {
            // If parsing fails, assume it's already a relative URL
            console.log('URL parsing failed, using as-is:', url);
        }

        // Hide the submit buttons
        const submitButtons = document.querySelector('div.product__submit__buttons');
        if (submitButtons) {
            submitButtons.style.display = 'none';
        }

        // Create or get the custom button container
        let customButtonContainer = document.getElementById('if-custom-comic-button');
        if (!customButtonContainer) {
            customButtonContainer = document.createElement('div');
            customButtonContainer.id = 'if-custom-comic-button';
            customButtonContainer.style.marginBottom = '1rem';

            const form = document.querySelector('form.shopify-product-form');
            if (form) {
                form.prepend(customButtonContainer);
            }
        }

        // Create the "See Comic Details" button
        customButtonContainer.innerHTML = `
      <button type="button" class="btn btn--primary btn--solid btn--medium btn--advanced" style="width: 100%;">
        <span>See Comic Details</span>
      </button>`;

        // Add click event to open URL in new tab
        const button = customButtonContainer.querySelector('button');
        if (button) {
            button.addEventListener('click', () => {
                window.open(url, '_blank');
            });
        }

        return;
    }

    // If no variant_url, make sure submit buttons are visible and remove custom button
    const submitButtons = document.querySelector('div.product__submit__buttons');
    if (submitButtons) {
        submitButtons.style.display = '';
    }

    const customButtonContainer = document.getElementById('if-custom-comic-button');
    if (customButtonContainer) {
        customButtonContainer.remove();
    }
}


function products_out_of_stock() {
    if (!window.productJsonData || !productJsonData.variants) {
        console.error('productJsonData.variants not available in products_out_of_stock');
        return;
    }

    const variants = productJsonData.variants;

    // Map keyed by image id -> { anyAvailable: boolean, mediaSlideParent: Element|null, mobileThumbnailParents: Set<Element> }
    const imageMap = new Map();
    // Map keyed by DOM element (when no image id) -> same shape as above
    const elementMap = new Map();

    for (const variant of variants) {
        // Treat variants with variant_url as available as your original function did
        const isAvailable = variant.available === true || Boolean(variant.metafields?.variant_url);

        const desktopEl = variant.mediaSlideParent ?? null;
        const thumbEl = variant.mobileThumbnailParent ?? null;

        const imageId = variant.featured_image?.id ?? variant.featured_media?.id ?? null;

        if (imageId != null) {
            let entry = imageMap.get(imageId);
            if (!entry) entry = { anyAvailable: false, mediaSlideParent: desktopEl, mobileThumbnailParents: new Set() };
            if (isAvailable) entry.anyAvailable = true;
            if (!entry.mediaSlideParent && desktopEl) entry.mediaSlideParent = desktopEl;
            if (thumbEl) entry.mobileThumbnailParents.add(thumbEl);
            imageMap.set(imageId, entry);
        } else {
            // No image id: group by DOM element (prefer desktopEl, fall back to thumbEl)
            const key = desktopEl || thumbEl;
            if (!key) {
                // nothing to mark for this variant
                continue;
            }
            let entry = elementMap.get(key);
            if (!entry) entry = { anyAvailable: false, mediaSlideParent: desktopEl, mobileThumbnailParents: new Set() };
            if (isAvailable) entry.anyAvailable = true;
            if (!entry.mediaSlideParent && desktopEl) entry.mediaSlideParent = desktopEl;
            if (thumbEl) entry.mobileThumbnailParents.add(thumbEl);
            elementMap.set(key, entry);
        }
    }

    const OUT_CLASS = 'if-product-image-out-of-stock';
    const THUMB_CLASS = 'if-product-image-out-of-stock-thumb';

    function applyEntry(entry) {
        // Desktop gallery element: query for child exactly like your original code
        if (entry.mediaSlideParent) {
            const imgNode = entry.mediaSlideParent.querySelector('div.product-gallery__media--image');
            if (imgNode) {
                if (entry.anyAvailable) {
                    imgNode.classList.remove(OUT_CLASS);
                } else {
                    imgNode.classList.add(OUT_CLASS);
                }
            }
        }

        // Mobile thumbnails (can be multiple)
        for (const thumbEl of entry.mobileThumbnailParents) {
            if (!thumbEl) continue;
            if (entry.anyAvailable) {
                thumbEl.classList.remove(THUMB_CLASS);
            } else {
                thumbEl.classList.add(THUMB_CLASS);
            }
        }
    }

    // Apply to all groups
    for (const [, entry] of imageMap) applyEntry(entry);
    for (const [, entry] of elementMap) applyEntry(entry);
}


function products_find_parent_elements() {
    // Add null checks
    if (!window.productJsonData) {
        console.error('productJsonData is not defined');
        return;
    }

    if (!productJsonData.variants || !Array.isArray(productJsonData.variants)) {
        console.error('productJsonData.variants is not available or not an array');
        return;
    }

    const isMobileView = is_mobile();

    for (const variant of productJsonData.variants) {
        // Skip if variant doesn't have schemaImage
        if (!variant.schemaImage) {
            console.log('Variant has no schemaImage:', variant.title || variant.id);
            variant.mediaSlideParent = null;
            continue;
        }

        // Extract the filename from the schemaImage URL path (unique per image, unlike v= which is shared across all product images)
        const pathPart = variant.schemaImage.split('?')[0];
        const filename = pathPart.split('/').pop();
        if (!filename) {
            console.log('Could not extract filename from schemaImage:', variant.schemaImage);
            variant.mediaSlideParent = null;
            continue;
        }

        // Find the matching gallery image with data-product-image attribute
        const galleryImg = document.querySelector(`img[data-product-image][src*="${filename}"]`);

        if (galleryImg) {
            // Find the parent div.product-gallery__media-slide
            const mediaSlide = galleryImg.closest('.product-gallery__media-slide');

            if (mediaSlide) {
                // Store the media slide element itself
                variant.mediaSlideParent = mediaSlide;
            } else {
                console.log('Parent .product-gallery__media-slide not found for filename:', filename);
                variant.mediaSlideParent = null;
            }
        } else {
            // console.log('Gallery image not found for v=', vParam);
            variant.mediaSlideParent = null;
        }

        // Mobile thumbnails (extra set)
        if (isMobileView && variant.featured_media?.id) {
            const mobileThumb = document.querySelector(`div.product-single__thumbnail[data-id="${variant.featured_media.id}"]`);
            if (mobileThumb) {
                variant.mobileThumbnailParent = mobileThumb;
            } else {
                variant.mobileThumbnailParent = null;
            }
        }
    }
}


function products_validate_variant_in_url(recheckAttempt = 0) {
    const scheduleRecheck = () => {
        if (recheckAttempt >= 2) return;
        const delayMs = recheckAttempt === 0 ? 350 : 900;
        setTimeout(() => products_validate_variant_in_url(recheckAttempt + 1), delayMs);
    };

    const params = new URLSearchParams(window.location.search);
    const variantParam = params.get('variant');
    if (variantParam) {
        const visibleVariantIds = (window.productJsonData?.visibleVariantIds || [])
            .map(id => parseInt(id, 10))
            .filter(Number.isFinite);

        const variantId = parseInt(variantParam, 10);
        if (Number.isFinite(variantId) && visibleVariantIds.length && !visibleVariantIds.includes(variantId)) {
            const variantPageMap = window.ifProductPagingData?.variantPageMap || {};
            const targetPage = parseInt(variantPageMap[String(variantId)], 10);
            const currentPage = Math.max(1, parseInt(params.get('page_num') || '1', 10) || 1);

            if (Number.isFinite(targetPage) && targetPage > 0 && targetPage !== currentPage) {
                const url = new URL(window.location.href);
                if (targetPage <= 1) {
                    url.searchParams.delete('page_num');
                } else {
                    url.searchParams.set('page_num', String(targetPage));
                }

                // Preserve the variant from the original URL so the destination page can
                // select/highlight that exact variant after redirect.
                url.searchParams.set('variant', String(variantId));

                if (!window.ifNavigatingToVariantPage) {
                    window.ifNavigatingToVariantPage = true;
                    window.location.href = url.toString();
                }
                return;
            }
        }
    }

    const selectedSlide = document.querySelector('div.product-gallery__media-slide.if-selected-variant');
    if (!selectedSlide) {
        scheduleRecheck();
        return;
    }
    if (!selectedSlide.querySelector('div.if-product-image-out-of-stock')) return;

    const fallbackSlide = Array.from(document.querySelectorAll('div.product-gallery__media-slide')).find(slide => {
        if (slide === selectedSlide) return false;
        if (window.getComputedStyle(slide).display === 'none') return false;
        return !slide.querySelector('div.if-product-image-out-of-stock');
    });

    if (!fallbackSlide) {
        scheduleRecheck();
        return;
    }

    const fallbackVariant = (window.productJsonData?.variants || []).find((variant) => {
        return variant.mediaSlideParent === fallbackSlide;
    }) || null;

    if (fallbackVariant) {
        products_set_variant_selection_silently(fallbackVariant);
    }

    // Ensure class swaps even if no click handler is bound in this context.
    if (!fallbackSlide.classList.contains('if-selected-variant')) {
        selectedSlide.classList.remove('if-selected-variant');
        fallbackSlide.classList.add('if-selected-variant');
    }
}


function get_more_product_data() {
    // Get the stable product path from the current URL
    const urlPath = window.location.pathname;

    // Get last 2 path segments (e.g., "products/some-product")
    const pathParts = urlPath.split('/').filter(part => part);
    const lastTwoParts = pathParts.slice(-2).join('/');

    // Collect all ld+json scripts
    const scripts = document.querySelectorAll('script[type="application/ld+json"]');

    // Parse and filter by @id containing the last 2 path segments
    const matchingData = Array.from(scripts)
        .map(el => {
            try {
                return JSON.parse(el.textContent);
            } catch {
                return null;
            }
        })
        .filter(obj => obj && obj['@id'] && obj['@id'].includes(lastTwoParts));

    // Inspect the result
    window.productJsonDataMore = matchingData;

    // Merge the data if available
    merge_product_data();
}


function merge_product_data() {
    if (!window.productJsonData || !window.productJsonData.variants) {
        return;
    }

    if (!window.productJsonDataMore || !window.productJsonDataMore.length) {
        return;
    }

    let moreVariants = [];

    for (const entry of window.productJsonDataMore) {
        if (!entry) continue;

        if (Array.isArray(entry.hasVariant) && entry.hasVariant.length) {
            moreVariants = entry.hasVariant;
            break;
        }

        if (Array.isArray(entry['@graph'])) {
            const productNode = entry['@graph'].find(function (node) {
                return Array.isArray(node?.hasVariant) && node.hasVariant.length;
            });

            if (productNode) {
                moreVariants = productNode.hasVariant;
                break;
            }
        }

        if (Array.isArray(entry)) {
            const nestedProduct = entry.find(function (node) {
                return Array.isArray(node?.hasVariant) && node.hasVariant.length;
            });

            if (nestedProduct) {
                moreVariants = nestedProduct.hasVariant;
                break;
            }
        }
    }

    if (!moreVariants.length) return;

    // Create a map of variant ID to additional data for quick lookup
    const moreDataMap = {};

    moreVariants.forEach(moreVariant => {
        // Extract variant ID from the @id URL (format: "/products/..?variant=12345#variant")
        const match = moreVariant['@id'].match(/variant=(\d+)/);
        if (match) {
            const variantId = parseInt(match[1]);
            moreDataMap[variantId] = {
                gtin: moreVariant.gtin,
                schemaImage: moreVariant.image,
                schemaName: moreVariant.name,
                schemaOffers: moreVariant.offers
            };
        }
    });

    // Merge the data into productJsonData.variants
    productJsonData.variants.forEach(variant => {
        if (moreDataMap[variant.id]) {
            // Add the additional data to the variant
            Object.assign(variant, moreDataMap[variant.id]);
        }
    });
}


function products_setup_media_slider_pagination() {
    const slider = document.querySelector('div.product-gallery div.product-gallery__media-slider');
    if (!slider) return;

    const allSlides = Array.from(slider.querySelectorAll('div.product-gallery__media-slide'));
    if (allSlides.length === 0) return;

    const pageSize = 50;
    let currentPage = 1;

    if (!document.getElementById('if-product-gallery-pagination-style')) {
        const style = document.createElement('style');
        style.id = 'if-product-gallery-pagination-style';
        style.textContent = '.if-pagination-hidden { display: none !important; }';
        document.head.appendChild(style);
    }

    let breadcrumbContainer = slider.previousElementSibling;
    if (!breadcrumbContainer || !breadcrumbContainer.classList.contains('if-product-gallery-pagination')) {
        breadcrumbContainer = document.createElement('div');
        breadcrumbContainer.className = 'if-product-gallery-pagination';
        breadcrumbContainer.style.marginBottom = '12px';
        slider.parentNode.insertBefore(breadcrumbContainer, slider);
    }

    const getBaseVisibleSlides = () => {
        return allSlides.filter(slide => slide.style.display !== 'none');
    };

    const renderBreadcrumbs = (pageCount) => {
        breadcrumbContainer.innerHTML = '';

        if (pageCount > 1) {
            for (let page = 1; page <= pageCount; page++) {
                const button = document.createElement('button');
                button.type = 'button';
                button.textContent = String(page);
                button.setAttribute('aria-label', `Go to gallery page ${page}`);
                button.setAttribute('aria-current', page === currentPage ? 'page' : 'false');
                button.style.margin = '0';
                button.style.padding = '0';
                button.style.border = '0';
                button.style.background = 'transparent';
                button.style.cursor = page === currentPage ? 'default' : 'pointer';
                button.style.fontWeight = page === currentPage ? '700' : '400';
                button.disabled = page === currentPage;

                button.addEventListener('click', () => {
                    currentPage = page;
                    applyPagination();
                });

                breadcrumbContainer.appendChild(button);

                if (page < pageCount) {
                    const separator = document.createElement('span');
                    separator.textContent = ' / ';
                    breadcrumbContainer.appendChild(separator);
                }
            }
        }

        products_attach_series_nav_links(breadcrumbContainer);
    };

    const applyPagination = () => {
        const visibleSlides = getBaseVisibleSlides();
        const pageCount = Math.max(1, Math.ceil(visibleSlides.length / pageSize));

        if (currentPage > pageCount) currentPage = pageCount;
        if (currentPage < 1) currentPage = 1;

        allSlides.forEach(slide => {
            slide.classList.remove('if-pagination-hidden');
        });

        visibleSlides.forEach((slide, index) => {
            const page = Math.floor(index / pageSize) + 1;
            if (page !== currentPage) {
                slide.classList.add('if-pagination-hidden');
            }
        });

        renderBreadcrumbs(pageCount);
    };

    window.ifProductGalleryPagination = {
        refresh: applyPagination,
        reset: () => {
            currentPage = 1;
            applyPagination();
        }
    };

    applyPagination();
    products_add_series_links_to_pagination();
}


function products_refresh_media_slider_pagination(resetToFirstPage = false) {
    const pagination = window.ifProductGalleryPagination;
    if (!pagination) return;

    if (resetToFirstPage && typeof pagination.reset === 'function') {
        pagination.reset();
        return;
    }

    if (typeof pagination.refresh === 'function') {
        pagination.refresh();
    }
}


// At 768–1023px, when the user swipes/clicks the carousel, sync the dropdown to the
// newly-selected slide so the correct variant is reflected in the add-to-cart form.
function products_setup_slider_variant_sync() {
    if (window._ifSliderVariantSyncBound) return;
    window._ifSliderVariantSyncBound = true;

    const gallery = document.querySelector('div.product-gallery div.product-gallery__media-slider');
    if (!gallery) return;

    const observer = new MutationObserver(function (mutations) {
        // Only act at 768–1023px viewport width
        const vp = window.innerWidth;
        if (vp < 768 || vp >= 1024) return;

        for (const mutation of mutations) {
            if (mutation.type !== 'attributes' || mutation.attributeName !== 'class') continue;

            const slide = mutation.target;
            if (!slide.classList.contains('product-gallery__media-slide')) continue;
            if (!slide.classList.contains('is-selected')) continue;

            // Find the variant whose mediaSlideParent matches this slide
            const variants = window.productJsonData?.variants;
            if (!variants) return;

            const matchingVariant = variants.find(v => v.mediaSlideParent === slide);
            if (!matchingVariant) return;

            // Sync selection without triggering theme popout click handlers that rewrite the URL.
            products_set_variant_selection_silently(matchingVariant);

            break; // only one slide becomes selected per mutation batch
        }
    });

    observer.observe(gallery, { subtree: true, attributes: true, attributeFilter: ['class'] });
}


// At 768–1023px, the theme hides .product-single__thumbnails for grid/stacked
// layouts via template-product.css (now patched to start at 1024px instead of 768px).
// This JS fix ensures that even if Flickity measured cells while the element was hidden
// (a race condition between CSS loading and the deferred product-info.js), the nav is
// properly resized after initialization. We use customElements.whenDefined so this code
// runs *after* product-info.js has called initProductSlider and created flktyNav.
function products_fix_thumbnail_display() {
    customElements.whenDefined('product-info').then(function () {
        document.querySelectorAll('product-info[data-tall-layout="true"]').forEach(function (productInfo) {
            var vp = window.innerWidth;
            if (vp < 768 || vp >= 1024) return;

            var thumbs = productInfo.querySelector('[data-product-single-media-thumbs]');
            if (!thumbs) return;

            // Inline style wins over CSS class rules (no !important needed)
            thumbs.style.display = 'flex';

            requestAnimationFrame(function () {
                if (productInfo.flktyNav) {
                    productInfo.flktyNav.resize();
                }
            });
        });
    });

    // Handle viewport resize crossing the 768 / 1024 thresholds
    if (!window._ifThumbFixResizeBound) {
        window._ifThumbFixResizeBound = true;
        window.addEventListener('resize', function () {
            document.querySelectorAll('product-info[data-tall-layout="true"]').forEach(function (productInfo) {
                var thumbs = productInfo.querySelector('[data-product-single-media-thumbs]');
                if (!thumbs) return;

                var vp = window.innerWidth;
                if (vp >= 768 && vp < 1024) {
                    thumbs.style.display = 'flex';
                    requestAnimationFrame(function () {
                        if (productInfo.flktyNav) productInfo.flktyNav.resize();
                    });
                } else {
                    thumbs.style.removeProperty('display');
                }
            });
        });
    }
}